import { Box, Divider, Link, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { PageSeo } from './page-seo'

const SITEMAP_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Sitemap · TerraPlanner',
  url: 'https://terra-planner.com/sitemap',
}

const SITEMAP_SECTIONS = [
  {
    heading: 'Marketing',
    links: [
      { label: 'Home', path: '/', desc: 'Landing page' },
      { label: 'About', path: '/about', desc: 'Our story, roadmap, and data protection' },
      { label: 'Support', path: '/support', desc: 'Plans and pricing' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy Policy', path: '/legal', desc: 'How we handle your data (PIPEDA)' },
      { label: 'Terms of Service', path: '/legal', desc: 'Terms governing use of the service' },
    ],
  },
  {
    heading: 'Utility',
    links: [
      { label: 'Sitemap', path: '/sitemap', desc: 'This page' },
      { label: 'Attributions', path: '/attributions', desc: 'Open-source licences and acknowledgements' },
    ],
  },
]

const SitemapLink = ({ label, path, desc }) => (
  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
    <Link component={RouterLink} to={path} underline="hover" color="primary" fontWeight={500} variant="body2">
      {label}
    </Link>
    <Typography variant="caption" color="text.disabled" sx={{ flexShrink: 0 }}>
      {path}
    </Typography>
    {desc && (
      <Typography variant="body2" color="text.secondary">
        — {desc}
      </Typography>
    )}
  </Box>
)

export const Sitemap = () => {
  return (
    <Box sx={{ px: { xs: 3, md: 6 }, py: { xs: 6, md: 8 }, maxWidth: 720, mx: 'auto' }}>
      <PageSeo
        title="Sitemap"
        description="A full index of all pages on TerraPlanner."
        path="/sitemap"
        schema={SITEMAP_SCHEMA}
      />

      <Typography component="h1" variant="h4" fontWeight={700} gutterBottom>
        Sitemap
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 4, lineHeight: 1.75 }}>
        All publicly accessible pages on TerraPlanner.
      </Typography>

      <Stack spacing={4} divider={<Divider />}>
        {SITEMAP_SECTIONS.map((section) => (
          <Box key={section.heading}>
            <Typography variant="overline" fontWeight={600} color="text.primary" letterSpacing={1} display="block" mb={1.5}>
              {section.heading}
            </Typography>
            <Stack spacing={1.5}>
              {section.links.map((link) => (
                <SitemapLink key={link.label + link.path} {...link} />
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  )
}
